<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col cols="3">
                <v-text-field
                  v-model="search"
                  placeholder="Key in employee name here"
                  append-icon="search"
                  label="Search Employee"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>

              <v-col cols="4">
                <v-autocomplete 
                  v-model="leaveType"
                  :items="leaveTypes"
                  deletable-chips
                  small-chips
                  multiple
                  item-text="name"
                  item-value="id"
                  chips
                  hide-no-data
                  hide-selected
                  label="Leave Type Filter"
                  placeholder="Choose leave type"
                  @change="loadData(leaveType)"
                />
              </v-col>
              <v-spacer />
              
              <v-col cols="2">
                <leaves-employee-on-behalfs-dialog-create
                  v-if="$hasPermissionTo(['create leaves on behalf'])"
                  @created="loadData(leaveType)"
                />
              </v-col>
            </v-row>
          </v-card-actions>

          <v-skeleton-loader
            v-bind="{class:'mx-2'}"
            :loading="tableLoading"
            type="table-thead, table-row-divider@9, table-tfoot"
          >
            <v-data-table
              :headers="headers"
              :items="onbehalfLeaves"
              :search="search"
            >
              <template v-slot:item.approval_request.employee.person.name="{ item }">
                <div>
                  <span>
                    {{ item.approval_request.employee.person.name }}
                  </span>
                </div>
              </template>

              <template v-slot:item.leave_entitlement.leave_type.name="{ item }">
                <div>
                  <span>
                    {{ item.leave_entitlement.leave_type.name }}
                  </span>
                </div>
              </template>

              <template v-slot:item.start_date="{ item }">
                <div>
                  <span>
                    {{ $moment(item.start_date).format('D MMM YYYY') }}
                  </span>
                </div>
              </template>

              <template v-slot:item.end_date="{ item }">
                <div>
                  <span>
                    {{ $moment(item.end_date).format('D MMM YYYY') }}
                  </span>
                </div>
              </template>

              <template v-slot:item.requested_days="{ item }">
                <div>
                  <span>
                    {{ item.requested_days }}
                  </span>
                </div>
              </template>

              <template v-slot:item.action="{ item }">
                <v-btn
                  v-if="item.documents_count<2"
                  icon
                  @click="loadOnBehalfLeaveApplicationDocument(item)"
                >
                  <v-icon color="primary">
                    mdi-file-document
                  </v-icon>
                </v-btn>
                <leaves-employee-on-behalfs-dialog-view
                  v-else-if="$hasPermissionTo(['view leaves on behalf'])"
                  :leave-application="item"
                />
                <leaves-employee-on-behalfs-dialog-delete
                  v-if="$hasPermissionTo(['delete leaves on behalf'])"
                  :leave-application="item"
                  @deleted="loadData(leaveType)"
                />
              </template>
            </v-data-table>
          </v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      LeavesEmployeeOnBehalfsDialogCreate: () => import('@/components/employee/leaves/on-behalfs/DialogCreate'),
      LeavesEmployeeOnBehalfsDialogView: () => import('@/components/employee/leaves/on-behalfs/DialogView'),
      LeavesEmployeeOnBehalfsDialogDelete: () => import('@/components/employee/leaves/on-behalfs/DialogDelete'),
    },

    data () {
      return {
        search: null,
        onbehalfLeaves: [],
        tableLoading: false,
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'approval_request.employee.person.name',
          },
          {
            text: 'Leave Type',
            align: 'left',
            value: 'leave_entitlement.leave_type.name',
          },
          {
            text: 'Start Date',
            align: 'center',
            value: 'start_date',
          },
          {
            text: 'End Date',
            align: 'center',
            value: 'end_date',
          },
          {
            text: 'Days',
            align: 'center',
            value: 'requested_days',
          },
          {
            text: '',
            sortable: false,
            align: 'center',
            filterable: false,
            value: 'action',
          },
        ],
        leaveType: [14],
        leaveTypes: [],
      }
    },
    created () {
      this.loadData(this.leaveType)
    },
    methods: {
      loadData (leaveType) {
        this.tableLoading = true

        Promise.all([
          this.$api.onBehalfLeaveApplications().list(leaveType),
          this.$api.applyOnBehalfLeaveTypes().list(),
        ])
          .then(([entitlement, optionalLeaveType]) => {
            this.onbehalfLeaves = _.orderBy(entitlement.data, ['start_date', 'approval_request.employee.person.name', 'leave_type.name'], ['desc', 'asc', 'asc'])       
            this.leaveTypes = _.orderBy(optionalLeaveType.data, ['name'], ['asc'])   

            this.tableLoading = false
          })
      },
      loadOnBehalfLeaveApplicationDocument (item) {
        this.$api.onBehalfLeaveApplications().show(item.id)
          .then(res => {
            window.open(res.data[0].documents[0].file_url)
          })
      },
    },
  }
</script>
